import AddProductContainer from "../../../components/applications/eCommerce/addProducts";

const AddProduct = () => {
  return <AddProductContainer />;
};

export default AddProduct;
